/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
//**********Sticky Header**********
	$(window).on('scroll', function (){
		  var sticky = $('.site-header'),
		  scroll = $(window).scrollTop();
		  if (scroll >= 20) sticky.addClass('site-header--fixed');
		  else sticky.removeClass('site-header--fixed');
	});